import { useState } from "react";
import { Link } from "react-router-dom";

import sus1 from "../../images/datawithSS.png";
import sus2 from "../../images/sus2.png";
import sus3 from "../../images/traffic.png";

function StayInformed() {
  const articles = [
    {
      id: 1,
      badgeColor: "#006633",
      badgeText: "Clean Transport",
      title: "Netzence set to unveil clean mobility hailing App in June 2026",
      description:
        "At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, e, a quiet but critical shift is beginning to take shape...",
      source: "25/03/2026",
      link: "/blogpost5",
    },
    {
      id: 2,
      badgeColor: "#7BC216",
      badgeText: "Sustainable Farming",
      title: "Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in livestock systems",
      description:
        "Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave...                   ",
      source: "05/02/2026",
      link: "/blogpost3",
    },
    {
      id: 3,
      badgeColor: "#006633",
      badgeText: "Clean Transport",
      title: "2026 Climate Mobility Horizon: Nigeria’s New Income Engine – Netzence",
      description:
        "Nigeria is facing a potential silent public-health emergency – one that does not announce itself with sirens or breaking news alerts, but with chronic coughs, shortened lifespans...",
      source: "06/01/2026",
      link: "/blogpost4",
    },
  ];

  const ArticleCard = ({ article }) => {
    const { badgeColor, badgeText, title, description, source } = article;
    const [isImageHovered, setIsImageHovered] = useState(false);

    return (
      <div className="w-full rounded-2xl bg-white shadow-[0_8px_24px_rgba(149,157,165,0.2)] flex flex-col items-center p-0 pb-[24px] gap-4 cursor-pointer transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,102,51,0.18)] hover:brightness-105 hover:bg-[#eff9ed]">
        {/* Image */}
        <img
          src={[sus1, sus2, sus3][article.id - 1]}
          alt={title}
          onMouseEnter={() => setIsImageHovered(true)}
          onMouseLeave={() => setIsImageHovered(false)}
          className="w-full aspect-[379/282] object-cover rounded-t-2xl hover:brightness-75 transition-opacity"
        />

        {/* Content */}
        <div className="w-full px-4 xl:px-0 xl:max-w-[352px] flex flex-col items-start gap-4 hover:text-[#60a928] transition-colors">
          {/* Badge */}
          <div
            className="px-1.5 py-0.5 mt-[12px] mb-[12px] rounded text-white text-[14px] font-medium"
            style={{ backgroundColor: badgeColor }}
          >
            <span className="text-[14px] leading-[21px] font-medium ">
              {badgeText}
            </span>
          </div>

          {/* Text container */}
          <div className="w-full flex flex-col items-start gap-3">
            <h3 className="font-semibold text-[18px] text-[#3B3B3B]">
              {title}
            </h3>
            <p
              className={`font-normal text-[14px] transition-colors ${
                isImageHovered ? "text-green-500" : "text-[#898989]"
              }`}
            >
              {description}
            </p>
          </div>

          {/* Footer */}
          <div className="w-full flex justify-between items-center mt-[16px]">
            <span className="text-[14px] leading-[21px] text-[#3B3B3B]">
              {source}
            </span>
            <Link to={article.link} className="flex items-center gap-2">
              <span className="font-medium text-[14px] leading-5 text-[#006633]">
                READ MORE
              </span>
              <svg
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.57794 6.34668L0.359375 11.3468L1.40294 12.3467L7.14329 6.84662C7.28165 6.71401 7.35938 6.53418 7.35938 6.34668C7.35938 6.15917 7.28165 5.97934 7.14329 5.84674L1.40294 0.34668L0.359375 1.34656L5.57794 6.34668Z"
                  fill="#006633"
                  stroke="#006633"
                  strokeWidth="0.5"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="w-full max-w-[1201px] xl:h-[938px] flex flex-col items-start gap-12 mx-auto overflow-hidden mt-16 sm:mt-24 lg:mt-32 xl:mt-44 px-4 sm:px-8 xl:px-0">
      {/* Header row */}
      <div className="w-full flex flex-col md:flex-row md:items-center justify-between gap-6 md:gap-4">
        {/* Left: title and description */}
        <div className="w-full max-w-[717px] flex flex-col gap-4">
          <h2 className="font-bold text-[26px] sm:text-[30px] xl:text-[36px] text-[#3B3B3B] mt-5">
            Stay Informed on Sustainable{" "}
            <span className="text-[#0D924F]">Initiatives</span>.
          </h2>
          <p className="text-[16px] xl:text-[18px] text-[#3B3B3B]">
            Get access to top latest news on sustainability, carbon emission,
            carbon reduction and lots more.
          </p>
        </div>

        {/* Right: button */}
        <Link
          to="/blogs"
          className="w-[117px] h-[47px] flex-shrink-0 border-2 border-[#006633] rounded-xl flex items-center justify-center hover:bg-[#006633] hover:text-white py-3 gap-2.5"
        >
          <span className="font-medium text-[16px] text-[#006633] hover:text-white">
            View more
          </span>
          {/* Arrow is hidden in design */}
          <span className="hidden">→</span>
        </Link>
      </div>

      {/* Articles row */}
      <div className="w-full flex flex-wrap items-center justify-center gap-8">
        {articles.map((article) => (
          <div
            key={article.id}
            className="w-full md:w-[calc(50%-16px)] xl:w-[379px]"
          >
            <ArticleCard article={article} image={article.image} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default StayInformed;